import ScrollOut from 'scroll-out';

// core/separator
ScrollOut({
  once: true,
  threshold: 0.5,
  targets: '.wp-block-separator',
  onShown: (el) => {
    const x = el.classList.contains('wp-block-separator--full')
      ? 'var(--wp--custom--spacing--group--left)'
      : '0%';

    el.animate(
      [
        {
          opacity: 0,
          transform: 'scaleX(0)',
          transformOrigin: `${x} 50%`,
        },
        {
          opacity: 1,
          transform: 'scaleX(1)',
          transformOrigin: `${x} 50%`,
        },
      ],
      {
        duration: 1000,
        fill: 'both',
      }
    );
  },
  onHidden: (el) => {
    el.style.opacity = 0;
  },
});

// core/cover
// ScrollOut({
//   cssProps: {
//     visibleY: true,
//     viewportY: true,
//   },
//   targets:
//     // '.wp-block-cover, .site-main .wp-block-image, .wp-block-post-template > .wp-block-post',
//     '.wp-block-cover--hero',
// });
ScrollOut({
  targets: '.wp-block-cover--hero',
  once: true,
  threshold: 0.25,
});

[...document.querySelectorAll('.wp-block-group--section')].forEach((el) => {
  const targets = el.querySelectorAll(
    'h1, h2, .wp-block-column > p, .wp-block-button, .wp-block-image, .wp-block-post-featured-image, .wp-block-post-date, .wp-block-post-title, .wp-block-post-excerpt, .wp-block-post-author-name'
  );
  ScrollOut({
    cssProps: {
      index: true,
    },
    targets: targets,
    once: true,
    threshold: 0.25,
  });
});

[...document.querySelectorAll('.wp-block-post-content')].forEach((el) => {
  ScrollOut({
    cssProps: {
      index: true,
    },
    targets: el.children,
    once: true,
    threshold: 0,
  });
});

[...document.querySelectorAll('.wp-block-digiteam-toolkit-accordion')].forEach(
  (el) => {
    const targets = el.querySelectorAll(
      '.wp-block-digiteam-toolkit-accordion-item'
    );
    ScrollOut({
      cssProps: {
        index: true,
      },
      targets: targets,
      once: true,
      threshold: 0.25,
    });
  }
);
